import { useCRM } from '../utils/CRMContext';
import { useAuth } from '../utils/AuthContext';
import { canGrantTeamChat, canUseTeamChat } from '../utils/userRoles';

/** Live grant from the user directory, falling back to the signed-in profile. */
export function useCanUseTeamChat(): boolean {
  const { user } = useAuth();
  const { crmUsers } = useCRM();
  const me = crmUsers.find((u) => u.uid === user?.id);
  if (me) return canUseTeamChat(me);
  if (!user?.teamChatEnabled) return false;
  return canGrantTeamChat({
    role: user.role,
    isActive: true,
    is1099Contractor: user.is1099Contractor,
    isTestUser: false,
    isWorkstation: false,
  });
}
